import React from "react";

const MIcon = ({ name, filled, className = "" }) => (
  <span
    className={`material-symbols-outlined ${filled ? "filled" : ""} ${className}`}
  >
    {name}
  </span>
);

export default MIcon;
